var _style, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _line, _path7, _path8, _ellipse2, _line2, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeploymentEnvironmentEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{display:inline;fill:url(#SVGID_2_);}\n\t.st4{display:inline;fill:url(#SVGID_3_);}\n\t.st5{display:inline;fill:#F3F3F3;}\n\t.st6{display:inline;fill:url(#SVGID_4_);}\n\t.st7{display:inline;fill:#A3A3A3;}\n\t.st8{display:inline;fill:url(#SVGID_5_);}\n\t.st9{display:inline;fill:none;stroke:#A4A4A4;stroke-width:1.9486;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{display:inline;fill:url(#SVGID_6_);}\n\t.st11{display:inline;fill:url(#SVGID_7_);}\n\t.st12{display:inline;fill:#A4A4A4;}\n\t.st13{fill:url(#Path-Copy_1_);}\n\t.st14{fill:url(#Path_4_);}\n\t.st15{fill:url(#Path_5_);}\n\t.st16{fill:url(#Path_6_);}\n\t.st17{fill:url(#Path_7_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.4201,
    y1: 710.3653,
    x2: 50.2912,
    y2: 695.4281,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.5,75.4c-2.7,1.6-7.2,1.7-9.9,0.1L19.2,62c-2.7-1.6-2.8-4.2,0-5.8l3-1.8c2.7-1.6,7.2-1.7,9.9-0.1 l23.3,13.4c2.7,1.6,2.8,4.2,0,5.8L52.5,75.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1061,
    y1: 695.6722,
    x2: 31.1995,
    y2: 642.1426,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#A6A6A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3F3F3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.5,43.5c0-13.9-9.8-30.8-21.8-37.8c-6.1-3.5-11.6-3.8-15.6-1.5l0,0l-10.5,6.1l4.2,7.5c0,0.2,0,0.3,0,0.5 c0,13.7,9.5,30.3,21.3,37.5l4.7,8.4L62,57.7l0,0C66.1,55.4,68.5,50.5,68.5,43.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8451,
    y1: 675.194,
    x2: 57.5014,
    y2: 675.194,
    gradientTransform: "matrix(1 0 0 1 4.900208e-03 -637.994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.3,10.5c8.5-4.9,22.3,3.1,30.9,17.8s8.5,30.7,0,35.6s-22.3-3.1-30.9-17.8S11.7,15.4,20.3,10.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -13.8193 22.825)",
    className: "st5",
    cx: 35.7,
    cy: 37.2,
    rx: 16.6,
    ry: 28.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8968,
    y1: 702.1421,
    x2: 75.1718,
    y2: 660.0995,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.9,64.1L50.9,64.1L50.9,64.1L50.9,64.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.2,63.9L51,64L51.2,63.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3942,
    y1: 675.6397,
    x2: 50.7942,
    y2: 675.6397,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.7,62c-3.4,1.1-7.7,0.4-12.4-2.3C26,53.3,16.9,37.6,16.9,24.6c0-5.8,1.8-10,4.9-12.4 c0.1-0.1,0.2-0.2,0.3-0.3C22,12,21.8,12,21.7,12.1c-3.9,2-6.4,6.6-6.4,13.4c0,12.9,9.1,28.7,20.3,35.1c5.5,3.2,10.4,3.5,14.1,1.6 c0.3-0.2,0.7-0.4,1-0.6C50.4,61.8,50.1,61.9,49.7,62z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 35.7,
    y1: 37.2,
    x2: 35.7,
    y2: 19.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8506,
    y1: 702.05,
    x2: 51.0206,
    y2: 702.05,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M50.9,64.1L50.9,64.1L50.9,64.1L50.9,64.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4,
    y1: 675.6397,
    x2: 50.8,
    y2: 675.6397,
    gradientTransform: "matrix(1 0 0 1 0 -638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M37.3,59.8C26.1,53.3,17,37.6,17,24.6c0-5.8,1.8-10,4.9-12.4c0.1-0.1,0.2-0.2,0.3-0.3 c-0.1,0.1-0.3,0.1-0.4,0.2c-3.9,2-6.4,6.6-6.4,13.4c0,12.9,9.1,28.7,20.3,35.1c5.5,3.2,10.4,3.5,14.1,1.6c0.3-0.2,0.7-0.4,1-0.6 c-0.4,0.2-0.7,0.3-1.1,0.4C46.2,63.1,41.9,62.5,37.3,59.8z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -13.8193 22.825)",
    className: "st12",
    cx: 35.7,
    cy: 37.2,
    rx: 1.7,
    ry: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 35.7,
    y1: 37.2,
    x2: 45,
    y2: 47.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LightTheme_DataVis2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path-Copy_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -595.2695,
    y1: 390.661,
    x2: -596.0089,
    y2: 390.3419,
    gradientTransform: "matrix(57 0 0 -33 33991.9961 12941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy",
    className: "st13",
    d: "M61.2,42C73,49,73,60.2,61.3,67.2c-3.4,2-7.6,3.5-12.1,4.4c-1.5,0.3-3.1,0-4.1-0.6 c-0.4-0.2-0.8-0.6-1-1c-0.7-1.3,0.5-2.6,2.6-3c3.4-0.6,6.3-1.7,8.8-3.2c8.5-5,8.5-13.2-0.1-18.3s-22.5-5-31,0 c-6.3,3.8-8.1,9.6-4.4,14.4c0.9,1.2,0,2.6-2.1,3.2c-1.6,0.4-3.4,0.2-4.6-0.5c-0.3-0.2-0.6-0.4-0.8-0.7C7.5,55.2,9.9,47.2,18.6,42 C30.3,35.1,49.4,35.1,61.2,42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -591.9485,
    y1: 388.7868,
    x2: -590.8821,
    y2: 388.7868,
    gradientTransform: "matrix(41 0 0 -28 24288 10914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st14",
    d: "M55.4,16.9c-0.5-0.3-1-0.6-1.6-0.8c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.6-0.3-1-0.4 c0,0-0.1,0-0.1,0c-0.8-0.3-1.5-0.6-2.3-0.8c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.4-0.1-0.9-0.2-1.4-0.3 c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.4-0.1-0.8-0.1-1.2-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5-0.1 c-0.4,0-0.7-0.1-1.1-0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.3,0-0.5,0c-0.4,0-0.7,0-1.1-0.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.4,0 c-0.4,0-0.8,0-1.2,0c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.4,0c-0.5,0-1,0.1-1.5,0.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.1,0-0.2,0 c-0.8,0.1-1.7,0.2-2.5,0.3l-0.1,0c-0.2,0-0.5,0.1-0.7,0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.3,0.1-0.6,0.2-0.9,0.2 c-0.4,0.1-0.8,0.2-1.1,0.3c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.9,0.3-1.3,0.5c-0.1,0-0.1,0-0.2,0.1c-0.5,0.2-0.9,0.4-1.4,0.6 c-0.1,0.1-0.3,0.1-0.4,0.2c-0.5,0.2-1,0.5-1.5,0.8c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.3,0.2-0.5,0.3-0.8,0.5 s-0.4,0.3-0.6,0.5s-0.4,0.4-0.7,0.5c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.5,0.5-0.8,0.8c-0.1,0.1-0.1,0.1-0.1,0.2 c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.1-0.2,0.3-0.3,0.4c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.2-0.3,0.5-0.5,0.8c0,0.1,0,0.1-0.1,0.2 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1,0,0.1c-0.1,0.2-0.1,0.4-0.2,0.7c0,0.2-0.1,0.3-0.1,0.5 c0,0,0,0.1,0,0.1c0,0.2-0.1,0.5-0.1,0.7c0,0.2,0,0.3-0.1,0.5c0,0.1,0,0.1,0,0.2l0,16.8c0-0.2,0-0.4,0.1-0.7s0-0.5,0.1-0.7 c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.1-0.4,0.2-0.7c0.1-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.2-0.5,0.3-0.7c0.2-0.3,0.4-0.6,0.6-0.9 c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.6,0.7-0.9c0-0.1,0.1-0.1,0.1-0.2c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.2,0.4-0.4,0.7-0.5 s0.4-0.3,0.6-0.5c0.2-0.2,0.5-0.3,0.8-0.5c0.3-0.2,0.5-0.4,0.8-0.5c0.5-0.3,1-0.5,1.5-0.8l0.4-0.2c0.5-0.2,0.9-0.4,1.4-0.6 l0.2-0.1c0.5-0.2,1-0.4,1.6-0.5c0.4-0.1,0.7-0.2,1.1-0.3c0.3-0.1,0.6-0.2,0.9-0.2c0.4-0.1,0.8-0.2,1.2-0.3 c0.3-0.1,0.5-0.1,0.8-0.2c0.8-0.1,1.6-0.3,2.5-0.3c0.3,0,0.5,0,0.8-0.1c0.5,0,1-0.1,1.5-0.1c0.3,0,0.6,0,0.9,0c0.4,0,0.8,0,1.2,0 c0.3,0,0.7,0,1,0c0.3,0,0.7,0,1.1,0.1c0.4,0,0.7,0.1,1,0.1c0.3,0,0.7,0.1,1.1,0.1c0.3,0,0.7,0.1,1,0.1c0.4,0.1,0.8,0.1,1.2,0.2 c0.3,0.1,0.6,0.1,0.9,0.2c0.5,0.1,0.9,0.2,1.4,0.3c0.2,0.1,0.5,0.1,0.7,0.2c0.8,0.2,1.6,0.5,2.3,0.8c0.4,0.1,0.7,0.3,1.1,0.5 c0.2,0.1,0.4,0.2,0.6,0.2c0.5,0.3,1.1,0.5,1.6,0.8c3.2,1.9,5.2,4.2,6,6.6c0.3,0.8,0.4,1.6,0.4,2.4l0-16.8 C61.8,22.7,59.7,19.4,55.4,16.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -545.3062,
    y1: 386.7939,
    x2: -544.2487,
    y2: 386.7939,
    gradientTransform: "matrix(10 0 0 -24 5462.9995 9322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st15",
    d: "M20.5,32.8C20.5,32.8,20.5,32.8,20.5,32.8c0,0.2-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1 c0,0.1-0.1,0.2-0.2,0.3v0c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.4,0.1-0.5,0.1l-0.2,0c-0.1,0-0.2,0-0.4,0l-0.2,0 c-0.2,0-0.4,0-0.5,0l0,0c-0.2,0-0.4,0-0.5,0l-0.1,0c-0.2,0-0.3,0-0.5-0.1h0c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.3-0.2-0.6-0.4-0.9-0.7c-1.8-2.3-2.6-4.7-2.6-7.1l0,16.8 c0,2.4,0.9,4.8,2.6,7.1c0.2,0.3,0.5,0.5,0.9,0.7c0.2,0.1,0.4,0.2,0.5,0.2l0,0c0.1,0,0.2,0.1,0.2,0.1s0.1,0.1,0.2,0.1l0.1,0 c0.1,0,0.3,0.1,0.4,0.1h0h0c0.1,0,0.2,0,0.4,0.1l0.1,0l0.1,0l0.1,0c0.1,0,0.3,0,0.4,0l0,0c0.1,0,0.3,0,0.4,0h0.1l0.2,0H17 c0.1,0,0.1,0,0.2,0l0.2,0h0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.1l0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1 c0.1,0,0.2-0.1,0.2-0.1s0.1,0,0.1-0.1c0,0,0,0,0.1,0c0.2-0.1,0.3-0.2,0.5-0.3l0,0c0.1-0.1,0.2-0.2,0.3-0.3l0,0l0,0 c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0l0-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1l0-0.1c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2v0l0-16.8 C20.5,32.6,20.5,32.7,20.5,32.8L20.5,32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -582.2523,
    y1: 390.2136,
    x2: -581.1976,
    y2: 390.2136,
    gradientTransform: "matrix(25 0 0 -32 14600.001 12530)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st16",
    d: "M70,26.8c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0,0.4s0,0.3-0.1,0.5c0,0.2-0.1,0.3-0.1,0.4 c0,0.1-0.1,0.3-0.1,0.4s-0.1,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.2,0.5 c-0.1,0.2-0.1,0.2-0.2,0.4c-0.1,0.1-0.2,0.3-0.2,0.5c-0.1,0.2-0.1,0.2-0.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c-0.2,0.3-0.5,0.6-0.8,0.9l-0.2,0.2c-0.2,0.2-0.4,0.5-0.7,0.7 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.4,0.4s-0.3,0.2-0.4,0.4c-0.1,0.1-0.3,0.2-0.5,0.4c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.2,0.1-0.3,0.2-0.5,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.3-1,0.5-1.4,0.8 c-0.2,0.1-0.3,0.2-0.5,0.2c-0.3,0.2-0.7,0.3-1,0.5l-0.6,0.2c-0.3,0.1-0.7,0.3-1,0.4c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.4,0.1-0.7,0.2-1.1,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.2-1.5,0.5-2.3,0.7l-0.5,0.1c-0.8,0.2-1.6,0.4-2.5,0.5 c-0.4,0.1-0.7,0.1-1.1,0.1h-0.1c-0.4,0-0.7,0-1.1-0.1h0c-0.3,0-0.6-0.1-0.9-0.2l-0.1,0c-0.3-0.1-0.6-0.2-0.8-0.4 c-0.4-0.2-0.8-0.6-1-1c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0-0.4l0,17c0,0.3,0.1,0.5,0.2,0.7c0.2,0.4,0.6,0.8,1,1 c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.1,0,0.2,0.1l0.1,0c0.1,0,0.1,0,0.1,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.4,0.1h0h0 c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0H48c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5-0.1h0c0.8-0.2,1.7-0.3,2.5-0.5l0.5-0.1 c0.8-0.2,1.6-0.4,2.3-0.7l0.2,0c0.1,0,0.3-0.1,0.4-0.1c0.4-0.1,0.7-0.2,1.1-0.4l0.6-0.2c0.3-0.1,0.7-0.3,1-0.4 c0.2-0.1,0.4-0.2,0.6-0.3c0.4-0.2,0.7-0.3,1-0.5c0.2-0.1,0.3-0.2,0.5-0.2c0.5-0.2,1-0.5,1.4-0.8l0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2 c0.2-0.1,0.4-0.2,0.5-0.3l0.5-0.3c0.2-0.1,0.3-0.2,0.5-0.4l0.5-0.3c0.2-0.1,0.3-0.2,0.5-0.4c0.2-0.1,0.3-0.2,0.4-0.3 c0.1-0.1,0.3-0.2,0.4-0.4l0.2-0.2c0.1,0,0.1-0.1,0.2-0.2c0.2-0.2,0.5-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.2-0.2 c0.3-0.3,0.5-0.6,0.8-0.9l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.5 c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.1-0.3,0.2-0.5 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.3,0.1-0.4s0.1-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.2,0.1-0.2 s0-0.1,0-0.2c0-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.3,0.1-0.4c0-0.1,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3l0-17 C70,26.5,70,26.6,70,26.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -595.2547,
    y1: 390.7074,
    x2: -596.0602,
    y2: 390.3695,
    gradientTransform: "matrix(57 0 0 -33 33991.9961 12914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0E0E0"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "st17",
    d: "M61.2,13.6C73,20.5,73,31.7,61.3,38.7c-3.4,2-7.6,3.5-12.1,4.4c-1.5,0.3-3.1,0-4.1-0.6 c-0.4-0.2-0.8-0.6-1-1c-0.7-1.3,0.5-2.6,2.6-3c3.4-0.6,6.3-1.7,8.8-3.2C64,30.2,64,22,55.4,17s-22.5-5-31,0 c-6.3,3.8-8.1,9.6-4.4,14.4c0.9,1.2,0,2.6-2.1,3.2c-1.6,0.4-3.4,0.2-4.6-0.5c-0.3-0.2-0.6-0.4-0.8-0.7c-5.1-6.7-2.6-14.6,6.1-19.8 C30.3,6.6,49.4,6.6,61.2,13.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentEnvironmentEmpty);
export default __webpack_public_path__ + "static/media/deployment_environment_empty.37f16a9342fab246cdfa0b8ba8db7063.svg";
export { ForwardRef as ReactComponent };